/* @flow */

import { fromJS, Map } from 'immutable'
import i18n from '../helpers/i18n'
import type DataHandler, { PathType } from '../data_handler'

const preProcessDefault = (x: any): any => x

const translate = (path: PathType) => {
  const name = path.filter((part) => typeof part === 'string')
  return { label: i18n.deep(['attributes', 'labels'].concat(name)) }
}

const getBackendError = (backendValidations: ?mixed, path: PathType) => {
  // $FlowFixMe
  return Map.isMap(backendValidations) ? backendValidations.getIn(path.concat(0)) : null
}

export type ViewPropsType = {
  value: mixed,
  path: PathType,
  errorMessage: ?string,
  name: string,
  onChange: (mixed) => void,
  label: string
}

export const makeProps = (
  data: DataHandler,
  validation: Object | Array<Object>,
  backendValidations: ?mixed,
  globalOptions: ?Object
) => {
  // $FlowFixMe: fromJS not picked up by flow
  const immutableValidation: Map<string, mixed> = fromJS(validation)
  return (path: PathType, options?: Object = {}): ViewPropsType => {
    let { preProcess, ...others } = options
    const preProcessor = preProcess || preProcessDefault
    // $FlowFixMe property `label` of object literal. Property not found in others
    return {
      ...globalOptions,
      value: data.getIn(path),
      path: path,
      // $FlowFixMe
      errorMessage: immutableValidation.getIn(path) || getBackendError(backendValidations, path),
      name: path.join('-'),
      onChange: (value) => data.setIn(path, preProcessor(value)),
      ...(others.hasOwnProperty('label') ? {} : translate(path)),
      ...others
    }
  }
}
